import { gql } from '@apollo/client'

const UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS_MUTATION = gql`
  mutation updateAllergenIncludedAllergensDetails($id: ID!, $data: [ID!]) {
    updateAllergenIncludedAllergensDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      includedAllergens {
        id
      }
    }
  }
`

export default UPDATE_ALLERGEN_EXCLUDED_ALLERGENS_DETAILS_MUTATION
